module.exports = __webpack_public_path__ + "static/media/img_howto_web_illust1@2x.93fd8d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_howto_web_illust1@2x.png
// module id = 1074
// module chunks = 0